export type PromiseType <t extends Promise<any>> = t extends Promise<infer r> ? r : never;
export type ItemType <t extends readonly any[]> = t extends readonly (infer r)[] ? r : never;
export type StripNull <type> = type extends null ? never : type;
export type StripUndefined <type> = type extends undefined ? never : type;
export type PartialRequired <o, fields extends keyof o> = {
    [k in fields]-?: StripUndefined<o[k]>;
} & Pick<o, Exclude<keyof o, fields>>;

class AssertError extends Error {}
export function assert(condition: unknown, message: string): asserts condition {
    if (!condition) {
        throw new AssertError(message);
    }
}

export function isTypedArray <t> (list: any, isa: (i: any) => i is t): list is t[] {
    return list instanceof Array && list.every(isa);
}

export namespace time {
    export const second = 1000;
    export const minute = 60 * second;
    export const hour = 60 * minute;
    export const day = 24 * hour;
}
